// extracted by mini-css-extract-plugin
export default {"btn":"ui_btn__mJGJ9","input":"ui_input__nQx6U"};